import { Layers } from "lucide-react";
import type { ReactNode } from "react";
import { Badge } from "../../web/components/ui";
import type { GroupRow } from "./meta";

/**
 * The top of a product's pricing card in a group: the group, what this product overrides (`badge`, blue), what the group
 * sets (`summary`), and on the right its buttons (`actions`: Override...). As tall with the badge as without, so nothing under it
 * moves when one comes or goes. Opening the group is beside its picker, above (PricingTab.tsx GroupField).
 */
export function GroupCardHeader(
    props: Readonly<{
        group: Pick<GroupRow, "id" | "name">;
        badge?: { text: string; title: string };
        summary: ReactNode;
        actions?: ReactNode;
    }>,
) {
    const { group, badge } = props;
    return (
        <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
            <div className="min-w-0 space-y-0.5">
                <p className="m-0 flex min-h-5 flex-wrap items-center gap-x-1.5 gap-y-1 leading-5">
                    <Layers className="size-4 shrink-0 text-brand-ink" />
                    <span className="font-semibold">{group.name}</span>
                    {badge ? (
                        <Badge tone="blue" title={badge.title}>
                            {badge.text}
                        </Badge>
                    ) : null}
                </p>
                <p className="m-0 text-muted whitespace-pre-line">{props.summary}</p>
            </div>
            {props.actions ? <div className="flex shrink-0 flex-wrap items-center gap-1.5">{props.actions}</div> : null}
        </div>
    );
}
